/* External dependencies */
import { Action } from 'redux';
import { Epic, ofType } from 'redux-observable';
import { from } from 'rxjs';
import { switchMap, map, catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { gql } from '@apollo/client';

/* Local dependencies */
import { listDevicesRequest } from './service';
import { DeviceActionTypes } from './reducer';
import { listDevicesSuccess, listDevicesFailure, listDevice } from './actions';
import { RootState } from '../../../../redux/store';
import { anonymousClient } from '../../../../client/graphql';

export const listDevicesEpic: Epic<Action, Action, RootState> = (action$) => {
  return action$.pipe(
    ofType(DeviceActionTypes.LIST_DEVICE_REQUEST),
    switchMap(() => {
      return from(listDevicesRequest()).pipe(
        map((response) => listDevicesSuccess(response.devices)),
        catchError((error) =>
          of(listDevicesFailure(error instanceof Error ? error.message : 'Failed to fetch devices')),
        ),
      );
    }),
  );
};
